export default [
    // members sidebar index route
    {
        path: '/visitors',
        component: () => import(/* webpackChunkName: "residents-index" */ '@/views/visitors/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'visitors.index',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/visitors/index.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
